var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("SchemaTablePage", {
        ref: "tablePageRef",
        attrs: {
          "layout-mode": "tab",
          "show-summary": "",
          "search-schema": _vm.searchSchema,
          columns: _vm.tableColumns,
          "default-query": _vm.defaultQuery,
          request: _vm.request,
          "build-params": _vm.buildParams,
          "parse-result": _vm.parseResult,
          "table-attrs": _vm.tableAttrs,
        },
        scopedSlots: _vm._u([
          {
            key: "search-amountRange",
            fn: function ({ query }) {
              return [
                _c(
                  "div",
                  { staticClass: "amount-range" },
                  [
                    _c("el-input-number", {
                      attrs: {
                        controls: false,
                        placeholder: "最小金额",
                        min: 0,
                      },
                      model: {
                        value: query.minOrderAmount,
                        callback: function ($$v) {
                          _vm.$set(query, "minOrderAmount", $$v)
                        },
                        expression: "query.minOrderAmount",
                      },
                    }),
                    _c("div", { staticStyle: { width: "10px" } }),
                    _c("el-input-number", {
                      attrs: {
                        controls: false,
                        placeholder: "最大金额",
                        min: 0,
                      },
                      model: {
                        value: query.maxOrderAmount,
                        callback: function ($$v) {
                          _vm.$set(query, "maxOrderAmount", $$v)
                        },
                        expression: "query.maxOrderAmount",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "colStatusText",
            fn: function ({ row }) {
              return [
                _c("el-tag", { attrs: { size: "mini" } }, [
                  _vm._v(_vm._s(row.statusText)),
                ]),
              ]
            },
          },
          {
            key: "colMemberAccount",
            fn: function ({ row }) {
              return [
                _c("MemberAccountCell", {
                  attrs: {
                    row: row,
                    username: row.memberAccount,
                    uid: row.uid,
                    "vip-level": row.memberLevel,
                  },
                }),
              ]
            },
          },
          {
            key: "colOrderAmount",
            fn: function ({ row }) {
              return [_vm._v(_vm._s(_vm._f("centsToYuan")(row.orderAmount)))]
            },
          },
          {
            key: "colActions",
            fn: function ({ row }) {
              return [
                row.status === 3
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.openRiskDialog(row, true)
                          },
                        },
                      },
                      [_vm._v("审核")]
                    )
                  : _vm._e(),
                _vm.canWithdrawRefund(row.status)
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.openRefundDialog(row)
                          },
                        },
                      },
                      [_vm._v(" 退款 ")]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("RiskControlInfoDialog", {
        attrs: { visible: _vm.riskDialogVisible, row: _vm.riskRow },
        on: {
          "update:visible": function ($event) {
            _vm.riskDialogVisible = $event
          },
          audited: _vm.handleAudited,
        },
      }),
      _c("WithdrawRefundDialog", {
        attrs: { visible: _vm.refundDialogVisible, row: _vm.refundRow },
        on: {
          "update:visible": function ($event) {
            _vm.refundDialogVisible = $event
          },
          success: _vm.handleRefundSuccess,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }